import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: 'index',
    name: 'index',
    meta: { title: '首页', login: true, componentName: 'AdminIndex' },
    component: () => import('@/views/mb/AdminIndex.vue'),
    props: true
  },
  {
    path: 'operation',
    name: 'operation',
    meta: { title: '功能', login: true, componentName: 'AdminOperation' },
    component: () => import('@/views/mb/AdminOperation.vue'),
    props: true
  },
  {
    path: 'me',
    name: 'me',
    meta: { title: '个人中心', login: true, componentName: 'AdminMe' },
    component: () => import('@/views/mb/AdminMe.vue'),
    props: true
  },
  {
    path: 'login',
    name: 'login',
    meta: { title: '登录', login: false, componentName: 'AdminLogin' },
    component: () => import('@/views/mb/AdminLogin.vue'),
    props: true
  }
  // {
  //   path: 'test',
  //   name: '测试',
  //   meta: { title: '测试', login: false, componentName: 'TestPage' },
  //   component: () => import('@/views/mb/test/TestPage.vue')
  // }
] as RouteRecordRaw[]
